import { render, staticRenderFns } from "./baseConfig.vue?vue&type=template&id=f970978c&"
import script from "./baseConfig.vue?vue&type=script&lang=js&"
export * from "./baseConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f970978c')) {
      api.createRecord('f970978c', component.options)
    } else {
      api.reload('f970978c', component.options)
    }
    module.hot.accept("./baseConfig.vue?vue&type=template&id=f970978c&", function () {
      api.rerender('f970978c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/baseConfig.vue"
export default component.exports